import React from "react"
import {Link} from "react-router-dom"
import {checkAllowed, contextMenuItem, getPathAndQueryParams, setPathBack} from "../functions"
import {MenuItem} from "./MenuItem"

export class FolderElement extends React.Component {

    render() {

        let {k, auth, owner, item, lang, iconsObject, documents} = this.props

        const folder = item

        let icon = iconsObject['folderImgFull']
        if (!folder.folders.length && !folder.links.length && !folder.notes.length) {
            icon = iconsObject['folderImgEmpty']
        }
        if (item.isShare || item.accessLink) {
            if (!folder.folders.length && !folder.links.length && !folder.notes.length) {
                icon = iconsObject['folderPublicEmptyIcon']
            } else {
                icon = iconsObject['folderPublicIcon']
            }
        }

        const menuItemData = {
            key: k,
            item: 'folder',
            id: folder["_id"],
            parent: folder.parentFolder,
            from: 'view',
            isShare: item.isShare,
            accessLink: item.accessLink,
            name: item.name,
            thumb: icon
        }

        return (
            <div>
                <div className={"d-flex justify-content-center position-relative"}>
                    <Link
                        to={`/${lang.lang}/folder/${documents.opening}/${folder["_id"]}`}>
                        <div className={'hand-click'}
                             onContextMenu={(e) => {
                                 if (checkAllowed(auth, documents.owner)) {
                                     contextMenuItem(e, k)
                                 }
                             }}
                             onClick={() => {
                                 setPathBack(getPathAndQueryParams())
                             }}>
                            <img id={"img-folder"} src={icon}
                                 className={"w-100 img-folder rounded-4"}
                                 alt={"..."}/>
                        </div>
                    </Link>
                    {<MenuItem data={menuItemData}/>}
                    <div className={'hand-click'}
                         onClick={(e) => {
                             if (checkAllowed(auth, documents.owner)) {
                                 contextMenuItem(e, k)
                             }
                         }}>
                        {(!item.isShare || owner === 'trial-user') &&
                        <img id={"img-context-menu"} src={iconsObject['img_context_menu']}
                             className={"w-100 rounded-2"}
                             alt={"..."}/>}
                    </div>
                </div>
                <p id={"name-folder"}
                   className={"name-folder text-center mb-2 text-black p-0 fw-bold"}>{folder.name}
                </p>
            </div>
        )
    }
}